import React from "react"

const Mark = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9572 9.22492C11.1136 8.84762 11.2 8.43389 11.2 8C11.2 7.56611 11.1136 7.15238 10.9572 6.77508L15.3911 4.93642C15.785 5.88634 16 6.92411 16 8C16 9.07589 15.785 10.1137 15.3911 11.0636L10.9572 9.22492ZM9.22492 5.04282L11.0636 0.608932C10.1137 0.215017 9.07589 0 8 0C6.92411 0 5.88634 0.215017 4.93642 0.608933L6.77508 5.04282C7.15238 4.88636 7.56611 4.8 8 4.8C8.43389 4.8 8.84762 4.88636 9.22492 5.04282ZM5.04282 6.77508L0.608932 4.93642C0.215017 5.88634 0 6.92411 0 8C0 9.07589 0.215017 10.1137 0.608933 11.0636L5.04282 9.22492C4.88636 8.84762 4.8 8.43389 4.8 8C4.8 7.56611 4.88636 7.15238 5.04282 6.77508ZM6.77508 10.9572L4.93642 15.3911C5.88634 15.785 6.92411 16 8 16C9.07589 16 10.1137 15.785 11.0636 15.3911L9.22492 10.9572C8.84762 11.1136 8.43389 11.2 8 11.2C7.56611 11.2 7.15238 11.1136 6.77508 10.9572Z"
        fill="#E95444"
      />
    </svg>
  )
}

export default Mark
